export const oldPureEventsRange = (firstDatetime, secondDatetime, datetimestart, userId) => {
  return `SELECT * FROM pure_stat_event_new WHERE datetime >= ${firstDatetime} AND datetime <= ${secondDatetime} AND datetimestart = ${datetimestart} AND userid = ${userId};`
}

export const newPureEventsRange = (firstDatetime, secondDatetime, datetimestart, userId) => {
  return `SELECT * FROM road_points rp JOIN sensors s ON s.road_point_id = rp.id JOIN face f ON f.road_point_id = rp.id JOIN face_raw fr ON fr.road_point_id = rp.id WHERE rp.datetime >= ${firstDatetime} AND rp.datetime <= ${secondDatetime} AND rp.datetimestart = ${datetimestart} AND rp.user_id = ${userId};`
}
